import Aparecer from './Aparecer';
import BarraProgresso from './BarraProgresso';
import Recolher from './Recolher';
import type { AcaoItem } from '@/pages/gerenciar/painel/financeiro/relatorio/types';
import { formatarCentavos } from '@/pages/loja/utils';
import { dataBR, percentual } from '@/pages/gerenciar/painel/financeiro/relatorio/utils';

export default function SecaoAcao({ itens }: { itens: AcaoItem[] }) {
  if (itens.length === 0) return null;

  return (
    <Aparecer>
      <section className="rel-secao rounded-2xl border border-background-200 bg-white p-4 shadow-[0_1px_3px_rgba(16,24,40,0.04)] md:p-5">
        <h2 className="text-[15px] font-bold text-foreground-950">Ação entre amigos</h2>

        <div className="mt-4 space-y-6">
          {itens.map((a) => (
            <div key={a.rifa_id}>
              <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5">
                <p className="text-[14px] font-semibold text-foreground-900">
                  {a.premio || 'Ação entre amigos'}
                </p>
                {a.sorteio_em && (
                  <p className="text-[12px] text-foreground-500">Resultado {dataBR(a.sorteio_em)}</p>
                )}
              </div>

              <div className="mt-2 flex flex-wrap items-baseline justify-between gap-x-3">
                <span className="text-[13px] text-foreground-500">Números vendidos</span>
                <span className="text-[13px] font-semibold tabular-nums text-foreground-900">
                  {a.numeros_vendidos} de {a.numeros_total}
                </span>
              </div>
              <div className="mt-2">
                <BarraProgresso pct={percentual(a.numeros_vendidos, a.numeros_total)} cor="bg-accent-500" />
              </div>

              <div className="mt-2 flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5 text-[13px] text-foreground-600">
                <p>
                  <strong className="font-semibold text-foreground-900">
                    {formatarCentavos(a.vendido_centavos)}
                  </strong>{' '}
                  vendido de {formatarCentavos(a.potencial_centavos)}
                </p>
                <p>
                  {a.vendedores_com_venda} de {a.vendedores_total} vendedores já venderam
                </p>
              </div>

              {a.abatido_em_inscricoes_centavos > 0 && (
                <p className="mt-1.5 inline-flex items-center gap-1.5 rounded-full bg-success-50 px-2.5 py-1 text-[12px] font-medium text-success-700">
                  <i className="ri-shield-check-line" />
                  Abatido nas inscrições {formatarCentavos(a.abatido_em_inscricoes_centavos)}
                </p>
              )}

              {a.top_vendedores.length > 0 && (
                <Recolher rotulo="Ver ranking">
                  <ol className="space-y-1.5">
                    {a.top_vendedores.map((t, i) => (
                      <li key={i} className="flex items-center justify-between gap-2 text-[13px]">
                        <span className="flex min-w-0 items-center gap-2">
                          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-background-100 text-[11px] font-semibold text-foreground-600">
                            {i + 1}
                          </span>
                          <span className="truncate text-foreground-800">{t.nome}</span>
                        </span>
                        <span className="shrink-0 font-semibold tabular-nums text-foreground-900">
                          {t.numeros} {t.numeros === 1 ? 'número' : 'números'}
                        </span>
                      </li>
                    ))}
                  </ol>
                </Recolher>
              )}
            </div>
          ))}
        </div>
      </section>
    </Aparecer>
  );
}